import { createFileRoute } from '@tanstack/react-router'
import { AgreementSectionsSettings } from '@/features/organizations/settings/agreement-sections'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/agreement-sections'
)({
  component: AgreementSectionsSettings,
})
